import * as React from "react";
import classnames from "classnames";
import { Icon } from "@grandvisionhq/icons";
import Loader from "../../Loader/Loader/Loader.js";
/* empty css            */
const renderButtonContent = (icon = "", caption) => /* @__PURE__ */ React.createElement(React.Fragment, null, icon && /* @__PURE__ */ React.createElement("span", { className: "button__icon" }, /* @__PURE__ */ React.createElement(Icon, { name: icon })), /* @__PURE__ */ React.createElement("span", { className: "button__text" }, caption), /* @__PURE__ */ React.createElement("div", { className: "button__loader-wrapper" }, /* @__PURE__ */ React.createElement(Loader, { className: "button__loader" })));
const Button = ({
  caption,
  type = "button",
  variant = "solid",
  size = "medium",
  color = "primary",
  buttonId,
  disabled,
  isLoading,
  noHover,
  icon,
  btnRef,
  href,
  hrefTarget,
  className,
  form,
  onClick,
  tabIndex,
  ...rest
}) => {
  const classes = classnames(
    `button button--${variant} button--${size}`,
    { [`button--color-${color}`]: variant !== "barebones" },
    className,
    {
      _is_disabled: disabled,
      // link cannot have a disabled attribute so we need a class
      _is_loading: isLoading,
      _no_hover: noHover
    }
  );
  if (href) {
    return disabled ? /* @__PURE__ */ React.createElement("div", { className: classes, "data-t": rest["data-t"], style: rest.style }, renderButtonContent(icon, caption)) : /* @__PURE__ */ React.createElement(
      "a",
      {
        className: classes,
        href,
        target: hrefTarget,
        rel: hrefTarget === "_blank" ? "noreferrer noopener" : void 0,
        "aria-busy": isLoading,
        "data-t": rest["data-t"],
        "aria-label": rest["aria-label"],
        "aria-describedby": rest["aria-describedby"],
        "data-element-id": rest["data-element-id"],
        "data-description": rest["data-description"],
        onClick,
        tabIndex,
        style: rest.style
      },
      renderButtonContent(icon, caption)
    );
  }
  return (
    // eslint-disable-next-line jsx-a11y/role-supports-aria-props
    /* @__PURE__ */ React.createElement(
      "button",
      {
        type,
        id: buttonId,
        className: classes,
        onClick: !disabled && onClick || void 0,
        disabled: isLoading || disabled || false,
        "aria-invalid": rest["aria-invalid"],
        "aria-label": rest["aria-label"],
        "aria-describedby": rest["aria-describedby"],
        "aria-pressed": rest["aria-pressed"],
        "aria-busy": isLoading,
        "data-t": rest["data-t"],
        "data-element-id": rest["data-element-id"],
        "data-description": rest["data-description"],
        form,
        ref: btnRef,
        tabIndex,
        style: rest.style
      },
      renderButtonContent(icon, caption)
    )
  );
};
export {
  Button as default
};
//# sourceMappingURL=Button.js.map
